import { atom } from "recoil"

export const hasPreTeamMemberRequestIdState = atom({
  key: "atoms/bottomTab/hasPreTeamMemberRequestIdState",
  default: 0,
})
